export const feedbackTones = [
  "neutral",
  "info",
  "positive",
  "warning",
  "critical",
] as const;

export type FeedbackTone = (typeof feedbackTones)[number];
export type FeedbackRole = "status" | "alert";
export type FeedbackLiveMode = "polite" | "assertive";

export type DialogDismissReason =
  | "close-button"
  | "escape"
  | "backdrop"
  | "native-close";

export interface DialogDismissOptions {
  readonly closeOnEscape: boolean;
  readonly closeOnBackdrop: boolean;
}

export function classNames(
  ...values: Array<string | false | null | undefined>
) {
  return values.filter(Boolean).join(" ");
}

export function joinIds(...values: Array<string | false | null | undefined>) {
  return [...new Set(values.filter((value): value is string => Boolean(value)))]
    .join(" ")
    .trim();
}

export function getFeedbackSemantics(
  tone: FeedbackTone,
  live = true,
): {
  readonly role: FeedbackRole | undefined;
  readonly liveMode: FeedbackLiveMode | undefined;
} {
  if (!live) return { role: undefined, liveMode: undefined };
  if (tone === "critical") {
    return { role: "alert", liveMode: "assertive" };
  }

  return { role: "status", liveMode: "polite" };
}

export function allowsDialogDismissal(
  reason: DialogDismissReason,
  options: DialogDismissOptions,
) {
  if (reason === "escape") return options.closeOnEscape;
  if (reason === "backdrop") return options.closeOnBackdrop;
  return true;
}

export function isDialogBackdropInteraction(
  target: EventTarget | null,
  currentTarget: EventTarget | null,
) {
  return target !== null && target === currentTarget;
}
